import React from "react";
import "../../../assets/css/cms/Navbar.css";
import { Link, useLocation } from "react-router-dom";
import { AiOutlineHome } from "react-icons/ai";
import { CMS_NAVBAR } from "../../../constants/cms";
const Navbar = (props) => {
  const userPermission = props.permission?.data;
  const router = useLocation();
  let relatedPath = router.pathname.split("/").slice(0, 4).join("/");

  return (
    <div className={"navbar_comp"}>
      <nav className={`${"bg_primary"} navbar navbar-expand-lg navbar-light`}>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className={`${"navbar_width"} navbar-nav`}>
            <li className="nav-items">
              <a
                href={"/cms/"}
                className={`${"nav_links"} ${
                  router.pathname == "/cms/" ? "nav_links_active" : ""
                }`}
              >
                <span>
                  <AiOutlineHome />
                </span>
              </a>
            </li>
            {
              // userPermission &&
              CMS_NAVBAR.map((obj, id) => {
                let flag = true;
                flag = userPermission?.find((permission) => {
                  if (obj.application == permission.content_type) {
                    return true;
                  }
                });
                if (flag || obj.application == "") {
                  let objLink = obj.link.split("/").slice(0, 4).join("/");
                  return (
                    <li className="nav-items" key={id}>
                      <a
                        key={id}
                        href={obj.link}
                        className={`${"nav_links"} ${
                          (relatedPath.startsWith(objLink + "/") || relatedPath === objLink) ? "nav_links_active" : ""
                        }`}
                      >
                        {obj.label}
                      </a>
                    </li>
                  );
                }
              })
            }
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;

{
  /* <p className={`${'yellow01'} ${'bb'}`}>Helllo</p> */
}
{
  /* <p className={`${'yellow01'} bg-info`}>Helllo</p> */
}
{
  /* <li className="nav-items">
                            <Link to="/cms/permission">
                                <a className={'nav_links'} aria-current="page" href="#">Permissions</a>
                            </Link>
                        </li>
                        <li className="nav-items">
                            <Link to="/cms/exam">
                                <a className={'nav_links'} aria-current="page" href="#">Exam</a>
                            </Link>
                        </li>
                        <li className="nav-items">
                            <Link to="/cms/premium-planner">
                                <a className={'nav_links'} aria-current="page" href="#">Premium-Planner</a>
                            </Link>
                        </li>
                        <li className={`nav-items`}>
                            <a className={'nav_links'} href="#">Institute Data</a>
                        </li>
                        <li className={`nav-items`}>
                            <a className={'nav_links'} href="#">Manage product-Mapping</a>
                        </li>
                        <li className={`nav-items`}>
                            <a className={'nav_links'} href="#">Articles/News</a>
                        </li>
                        
                        <li className={`nav-items`}>
                            <a className={'nav_links'} href="#">SEO</a>
                        </li>
                        <li className={`nav-items`}>
                            <a className={'nav_links'} href="#">Analytics</a>
                        </li>
                        <li className={`nav-items`}>
                            <a className={'nav_links'} href="#">Admission Budy</a>
                        </li>
                        <li className={`nav-items`}>
                            <a className={'nav_links'} href="#">School Data</a>
                        </li> */
}
